import { Component, OnInit } from '@angular/core';
import { LanguageService } from 'app/_services/language.service';

@Component({
  selector: 'fury-chronology-conf',
  templateUrl: './chronology-conf.component.html',
  styleUrls: ['./chronology-conf.component.scss']
})
export class ChronologyConfComponent implements OnInit {

  constructor(public languageService : LanguageService) { }

  ngOnInit() {
    // This is intentional
  }

}
